export default __webpack_public_path__ + "static/media/confirmation-ilustration.269aa109.svg";